<template lang="pug">

  v-dialog(id="modal0" ref="myModalRef" v-model="active" max-width="1170px" width="100%" transition="dialog-bottom-transition")

    material-card(color="primary" light max-width="100%" class="px-0 py-0" toolbar)

      template(v-slot:heading)

        v-toolbar(flat dark color="primary" height="45px")
          v-toolbar-title.white--text
            | Confirmar Escala

          .flex-grow-1

          v-toolbar-items
            v-btn(icon dark @click="active = false")
              v-icon(style="color: #fff !important" v-text="'mdi-close'")

      div(v-if="week" id="scale-data" class="scaleContainer px-2 pb-4 py-6" :class="$vuetify.breakpoint.name")

        br

        //-div(class="d-flex flex-column flex-lg-row flex-md-row align-center justify-center confirm-scale-container")
        div(class="confirm-scale-container")

          div(style="height: 100%;" class="d-flex flex-column align-center justify-center")
            //-p(class="confirm-scale-text" style="text-align: center; font-weight: bold; margin: 0;")
              | Você está prestes a criar essa seguinte escala para essa semana.
            //-p(style="text-align: center; margin: 0; font-weight: bold;")
              | Deseja continuar?
            p(class="confirm-scale-text")
              | Você confirma a criação da escala abaixo?

          v-card-actions.buttons-on-lg
            v-spacer
            v-btn(color="error" x-large @click="active = false").px-4
              | Cancelar
            v-btn(:loading="loading" :disabled="loading" color="success" x-large @click.stop.prevent="sendPlantoes(week)").mr-0.px-4
              | Confirmar
            v-spacer

        div(v-if="this.$vuetify.breakpoint.smAndUp" class="calendar-2")

          ul.row

            li(v-for="(period, pk) in ['morning', 'night']" :key="pk" :class="{ [period]: true, }")

              div.turn-flag
                span(v-if="pk === 0") Dia
                span(v-if="pk === 1") Noite

              template(v-for="(day, dk) in week.value")

                //-div(:key="dk" class="turn" :class="{expiredDay: isExpiredDay(day), expiredDay: day.isBefore(), anotherMonth: (day.get('month') !== actualMonth) }")
                //- div(:key="dk" class="turn" :class="{expiredDay: isExpiredDay(day), anotherMonth: (day.get('month') !== actualMonth) }")
                div(:key="dk" class="turn" :class="{expiredDay: day.isExpired, anotherMonth: (day.day.get('month') !== actualMonth) }")

                  div(v-if="pk === 0" :key="'day'+dk" class="day")
                    | {{ day.day.format('ddd - DD/MM') }}

                  div.space

                    div(v-for="(turn, t) in getTurnsToday(day, period)" :key="t" class="space-turn")

                      span.turn-hour
                        span.turn-hour-first Início às {{ turn.turnHour }}
                        span.turn-hour-second Duração: {{ turn.turnDuration }}

                      div.user-list

                        //- template(v-for="(user, k) in getTurnUsers(turn.turnID, day)")
                        template(v-for="(user, k) in turn.users")

                          //- template(v-if="true || k != 'confirmedDutys'")

                          span(:key="k" class="user" :class="{availableTurn: user.availableTurn, closedTurn: user.closedTurn}")
                            div(:class="['corner', 'top', 'left']")
                            div(:class="['corner', 'top', 'right']")
                            div(:class="['corner', 'bottom', 'left']")
                            div(:class="['corner', 'bottom', 'right']")

                            span(v-if="user.availableTurn && !user.closedTurn" :class="{availableTurn: user.availableTurn}")
                              //- template(v-if="!isExpiredDay(day)")
                              template(v-if="!day.isExpired")
                                | Disponível
                              template(v-else)
                                | Vencido
                            span(v-if="user.closedTurn && !user.availableTurn" :class="{closedTurn: user.closedTurn}") Fechado

                            span(v-if="user && !user.availableTurn && !user.closedTurn" :title="user.nome")
                              template(v-if="$vuetify.breakpoint.mdOnly")
                                | {{ user.nome.replace(/(.{10})..+/, "$1&hellip;") }}
                              template(v-else-if="$vuetify.breakpoint.lgOnly")
                                | {{ user.nome.replace(/(.{17})..+/, "$1&hellip;") }}
                              template(v-else)
                                | {{ user.nome.replace(/(.{30})..+/, "$1&hellip;") }}

        div(v-else).calendar-2

          ul.row

            li(v-for="(day, dk) in week.value" :key="dk" class="mobLi")

              template(v-for="(period, pk) in ['morning', 'night']")

                //- div(:key="pk" class="turn" :class="{ [period]: true, expiredDay: day.isBefore(), anotherMonth: (day.get('month') !== actualMonth) }")
                //- div(:key="pk" class="turn" :class="{ [period]: true, expiredDay: isExpiredDay(day), anotherMonth: (day.get('month') !== actualMonth) }")
                div(:key="pk" class="turn" :class="{ [period]: true, expiredDay: day.isExpired, anotherMonth: (day.day.get('month') !== actualMonth) }")

                  div.turn-flag
                    span(v-if="pk === 0") Dia
                    span(v-if="pk === 1") Noite

                  div.space

                    div(v-if="pk === 0" :key="'day'+dk" class="day")
                      | {{ day.day.format('ddd - DD/MM') }}

                    div(v-for="(turn, t) in getTurnsToday(day, period)" :key="t" class="space-turn")

                      span.turn-hour
                        span.turn-hour-first Início às {{ turn.turnHour }}
                        span.turn-hour-second Duração: {{ turn.turnDuration }}

                      div.user-list

                        //- template(v-for="(user, k) in getTurnUsers(turn.turnID, day)")
                        template(v-for="(user, k) in turn.users")

                          //- template(v-if="true || k != 'confirmedDutys'")

                          span(:key="k" class="user" :class="{availableTurn: user.availableTurn, closedTurn: user.closedTurn}")
                            div(:class="['corner', 'top', 'left']")
                            div(:class="['corner', 'top', 'right']")
                            div(:class="['corner', 'bottom', 'left']")
                            div(:class="['corner', 'bottom', 'right']")

                            span(v-if="user.availableTurn && !user.closedTurn" :class="{availableTurn: user.availableTurn}")
                              //- template(v-if="!isExpiredDay(day)")
                              template(v-if="!day.isExpired")
                                | Disponível
                              template(v-else)
                                | Vencido
                            span(v-if="user.closedTurn && !user.availableTurn" :class="{closedTurn: user.closedTurn}") Fechado

                            span(v-if="user && !user.availableTurn && !user.closedTurn") {{ user.nome.replace(/(.{25})..+/, "$1&hellip;") }}
                            b.removeUser &#10008;
                            b.confirmedUser &#10004;

</template>

<script>

  import { apiGetGroupScaleTurns } from '@/services/firebase'

  import MaterialCard from '@/components/base/MaterialCard'

  export default {
    name: 'ConfirmScaleModal',

    components: {
      'material-card': MaterialCard,
    },

    props: {
      actualMonth: {
        type: Number,
        default: () => undefined,
      },
      actualYear: {
        type: Number,
        default: () => undefined,
      },
      week: {
        type: Object,
        default: () => ({}),
      },
      /* isScaleExpiredDay: {
        type: Function,
        default: function (day) {
          return []
        },
      }, */
      getScaleTurnsToday: {
        type: Function,
        default: function (day, period) {
          return []
        },
      },
      /* getScaleTurnUsers: {
        type: Function,
        default: function (turnID, day) {
          return []
        },
      }, */
      sendScalePlantoes: {
        type: Function,
        default: function (week) {},
      },
    },
    data () {
      return {
        active: false,
        loading: false,
      }
    },
    computed: {
      scaleID () {
        return this.$route.params.scaleID
      },
      groupID () {
        return this.$route.params.groupID
      },
    },

    /* watch: {
      show: {
        immediate: true,
        handler: function (newShow, oldShow) {
          const closing = oldShow === true && newShow === false
          if (closing) {
            // [24/01/25] console.log('[closing]')
            this.show = false
            this.$emit('close', false)
          }
        },
      },
      active: {
        immediate: true,
        handler: function (newActive, oldActive) {
          const opening = newActive === true
          if (opening) {
            // [24/01/25] console.log('confirmScaleModal[opening]')
            // this.show = true
          } else {
            // [24/01/25] console.log('confirmScaleModal[closing]')
          }
        },
      },
    }, */

    /* created () {
      // [24/01/25] console.log('confirmScaleModal[created]')
    },

    mounted () {
      // [24/01/25] console.log('confirmScaleModal[mounted]')
      // console.log(this.$parent)
    },

    destroyed () {
      // [24/01/25] console.log('confirmScaleModal[destroyed]')
    }, */

    methods: {
      open () {
        this.active = true
      },

      /* isExpiredDay (day) {
        return this.isScaleExpiredDay(day)
      }, */

      getTurnsToday (day, period) {
        return this.getScaleTurnsToday(day, period)
      },

      /* getTurnUsers (turnID, day) {
        return this.getScaleTurnUsers(turnID, day)
      }, */

      async sendPlantoes (week) {
        // [24/01/25] console.log('sendPlantoes[week]:', week)

        if (this.loading) return false

        // Dias da semana selecionada
        const daysOfWeek = week.value.map(day => day.dayFmtWzero) // Ano-Mes-Dia
        // [24/01/25] console.log('sendPlantoes[daysOfWeek]:', daysOfWeek)

        // Turnos

        this.loading = true
        const turns = await apiGetGroupScaleTurns(this.groupID, this.scaleID)
        this.loading = false

        if (!!turns === false) {
          alert('Não foi possível verificar os plantões da escala. Por favor, tente novamente ou fale com o nosso suporte.')
          return false
        }

        // [24/01/25] console.log('sendPlantoes[turns]:', turns)

        // Plantões dos turnos (da escala)
        const scaleDuties = []
        const turnsKeys = Object.keys(turns)
        turnsKeys.forEach(turnID => {
          const turn = turns[turnID]

          if (!!turn === true) {
            const isSolo = !!turn.shiftType === true && turn.shiftType === 'solo'

            if (!isSolo && turn.plantoes) {
              const turnDutiesDates = Object.keys(turn.plantoes)
              scaleDuties.push(...turnDutiesDates)
            }
          }
        }) // Ano-Mes-Dia

        // Verifica se os turnos tem algum plantão, se tiver, verifica se algum dos plantões existentes está dentro da semana selecionada
        const hasDutiesOnSelectedWeek = scaleDuties.length > 0 ? scaleDuties.some(scaleDutyDate => !!scaleDutyDate && daysOfWeek.indexOf(scaleDutyDate) >= 0) : false

        // [24/01/25] console.log('sendPlantoes[scaleDuties]:', scaleDuties)

        if (!hasDutiesOnSelectedWeek) {
          alert('Você precisa adicionar pelo menos um plantão para disparar a semana.')
          return false
        }

        this.active = false

        // Executa disparo
        this.$store.commit('CLEAR_EDIT_SCALE_CTRL_Z')
        return this.sendScalePlantoes(week)
      },
    },
  }

</script>

<style scoped lang="scss">

.scaleContainer {
  // width: 100%;
  padding: 12px;
  // margin-right: auto;
  // margin-left: auto;
}

.turn-hour-first,
.turn-hour-second {
  display: block;
}

span.turn-hour-first {
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  padding: 7px 0 2px 0;
}

span.turn-hour-second {
  font-size: 12.5px;
  font-weight: 400;
  line-height: 12.5px;
  padding: 2px 0 7px 0;
}

.confirm-scale-container {
  // background-color: red;
  /* @media(min-width: 1264px) {
    padding-left: 250px;
  } */
  margin-bottom: 33px;
  color: #777;
  font-size: 18px;

  p {
    margin: 4px 0;
  }
}

.buttons-on-lg {
  margin: 10px 0 30px 0;
  // background-color: red;
  /* @media(min-width: 1264px) {
    padding-left: 40px;
  } */
}

form{
  width: 100%;
}

.btn{
  width: 100%;
  border: thin solid #ccc;
  margin-top: 10px;
}

.btn-warning{
  font-weight: bold;
}

#scale-data{
  /* &.sm {
    .calendar-2 {
      ul {
        display: flex;
        .send-pushs-bar{
          .v-input--checkbox {
            position: static;
          }
        }
      }
    }
  }

  &.md {
    .calendar-2 {
      ul {
        li {
          .turn {
            flex: 1;
            min-width: 100px;
            .turn-hour{
              font-size: 12px;
            }
            .user-list {
              .user {
                span {
                  max-width: 65px;
                }
              }
            }
          }
        }
      }
    }
  } */

  color: #888;
  background-color: #fff;
  width: 100%;
  // min-height: 100vh;
  .navbar{
    .navbar-brand{
      color: #0069d9;
      font-size: 26px;
    }

    .group-name{
      color: #0069d9;
      font-size: 22px;
    }
  }

  .my-turns{
    text-decoration: none;
    line-height: 70px;
    font-size: 22px;
  }

  .scale-data{
    input{
      border: none;
      border-bottom: thin solid #ccc;
      border-radius: 0px;

      &:focus{
        border-radius: 4px;
      }
    }
  }

  .day{
    display: block;
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    line-height: 30px;
    text-align: center;
  }

  .calendar, .calendar-2 {
    ul{
      list-style: none;
      white-space:nowrap;
      display: block;
      padding: 0;
      margin: 0;
      width: 100%;
      position: relative;
      overflow-x: auto;

      li{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        align-items: stretch;
        align-content: stretch;
        margin-bottom: 2px;
        min-height: 115px;
      }
    }

    .turn-flag {
      width: 40px;
      background-color: #000;
      writing-mode: vertical-rl;
      text-orientation: upright;
      font-weight: bold;
      opacity: 0.4;
      color: #fff;
      position: relative;
      margin: 0 2px;
      // margin: 0 5px;
      border-radius: 10px;
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0)
      }
      &.turn-day{
        border-radius: 10px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      }
      &.turn-night{
        border-radius: 10px;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        margin-top: 2px;
      }
    }
  }

.calendar {
  background-color: #aaa;
  cursor: not-allowed;

  .col-md {
    padding-bottom: 50px;
    margin-bottom: 50px;
    border-bottom: thin solid #ccc;

    .turn.expiredDay{
      // cursor: not-allowed;
      // background-color: #aaa;
      background-image: linear-gradient(180deg, rgba(170, 170, 170, 1), rgba(0, 0, 0, 0.5));

      .day {
        color: white;
      }

      .user{
        // cursor: not-allowed;
        background-color: #ff7c7c;
        border-color: #ff9f9f;

        b{
          display: none;
        }

        &.availableTurn {
          background-color: #ff5a5a;
          border-color: #ff9f9f;
        }
      }

      .user-plus{
        display: none;
      }
    }

    .turn.anotherMonth{
      background-color: #f4f4f4;
      &.expiredDay{
        background-image: linear-gradient(180deg, rgba(59, 59, 59, 1), rgba(59, 59, 59, 0.1));
        .day {
          color: white;
        }

        // background-color: #555;
        // background-image: linear-gradient(180deg, rgba(170, 170, 170, 1), rgba(0, 0, 0, 0.5));

        .user{
          // cursor: not-allowed;
          background-color: #ff7c7c;
          border-color: #ff9f9f;

          b{
            display: none;
          }

          &.availableTurn {
            background-color: #ff5a5a;
            border-color: #ff9f9f;
          }
        }
      }
    }
  }
}

  .calendar-2 {

    ul{
      // padding-bottom: 50px;

      .mobLi {
        flex-direction: column;
        padding-bottom: 10px;
        .turn {
          background: none !important;
          display: flex;
          min-height: 160px;

          &.expiredDay{
            // background-image: linear-gradient(180deg, rgba(170, 170, 170, 1), rgba(0, 0, 0, 0.5));
            background-color: #aaaaaa;
            .space {
              background-color: #aaa;
            }
            .day {
              color: white;
            }
            // cursor: not-allowed;
            .user{
              // cursor: not-allowed;
              background-color: #ff7c7c;
              border-color: #ff9f9f;

              b{
                display: none;
              }

              &.availableTurn {
                background-color: #ff5a5a;
                border-color: #ff9f9f;
              }
            }
            .user-plus{
              display: none;
            }
          }

          &.anotherMonth{
            .space {
              background-color: #f4f4f4;
            }
            &.expiredDay{
              background-image: linear-gradient(180deg, rgba(59, 59, 59, 1), rgba(59, 59, 59, 0.1));
              .day {
                color: white;
              }
              .space {
                background-color: #555;
              }
            }
          }

          &.morning {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            .turn-flag {
              background-color: #999;
            }
          }

          &.night {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            .turn-flag {
              background-color: #000;
            }
          }

          .turn-flag {
            margin: 0;
            border-radius: 0;
          }
          .space {
            width: 100%;
          }
        }
      }
      &.confirmedDutys{
        li{
          .space-turn{
            a{
              cursor: not-allowed;
            }
            .user-plus{
              display: none;
            }
            .removeUser{
              display: none;
            }
            .confirmedUser{
              display: block;
            }
          }
        }

      }

      li{

        &.morning{
          .turn, .turn-flag {
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
          }
          .turn-flag {
            background-color: #999;
          }
        }

        &.night{
          .turn, .turn-flag {
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
          }
          .turn-flag {
            background-color: #000;
          }
        }

        .turn{
          flex-grow: 1;
          margin: 0 2px;
          // margin: 0 5px;
          border: thin solid #ccc;
          display: block;
          border-radius: 10px;
          position: relative;
          overflow-y: auto;
          text-align: center;
          // min-width: 130px;
          max-width: 135px;

          .turn-hour{
            display: block;
            min-height: 40px;
            // margin-top: 10px;
            color: rgba(0, 0, 0, 0.7);
            font-size: 14px;
            font-weight: 500;
            background-color: rgba(255, 255, 255, 0.5);
          }

          // .turn-hour{
            // display: block;
            // width: 100%;
            // height: 25px;
            // margin-top: 10px;
            // font-size: 14px;
            // // font-weight: bold;
          // }

          .user-list{
            display: block;
            width: 100%;
            min-height: 95px;
            overflow: hidden;
            padding: 5px;

            .user{
              position: relative;
              display: flex;
              width: 100%;
              font-size: 13px;
              background-color: #fdab3d;
              // border-radius: 5px;
              color: white;
              font-weight: bold;
              padding: 5px;
              text-decoration: none;
              text-align: center;
              border: 2px solid #f1be80;
              margin-top: 5px;
              flex-flow: column;
              align-items: center;
              min-height: 40px;
              &:first-child{
                margin-top: 0px;
              }

              .corner {
                position: absolute;
                width: 2px;
                height: 2px;
                background: #f0c891;
                &.top {
                  top: -2px;
                }
                &.bottom {
                  bottom: -2px;
                }
                &.left {
                  left: -2px;
                }
                &.right {
                  right: -2px;
                }
              }

              &.availableTurn{
                background-color: #00cb72;
                border-color: #41da98;
                color: white;
                .corner {
                  background: #72e3b3;
                }
              }
              &.closedTurn{
                background-color: red;
                border-color: white;
                color: white;
                .corner {
                  background: red;
                }
              }

              span{
                text-overflow: ellipsis;
                // white-space: normal;
                max-width: 100px;
                max-height: 40px;
                vertical-align: middle;
                line-height: 1;
                flex: 1;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                overflow: hidden;
                // &::before {
                //   content: "...";
                //   position: absolute;
                //   bottom: 0;
                //   right: 0;
                // }
                // &::after {
                //   content: "";
                //   position: absolute;
                //   right: 0; /* note: not using bottom */
                //   width: 13px;
                //   height: 13px;
                //   background: #fdab3d;
                // }
              }
              b{
                position: absolute;
                right: 3px;
                top: 50%;
                transform: translateY(-50%);
              }
            }

            .user-plus{
              display: block;
              text-align: center;
              clear: both;
              padding: 5px;
              font-size: 14px;
              background-color: none;
              a{
                background-color: none;
              }
              button {
                margin: auto;
              }
            }
            .confirmedUser{
              display: none;
              color: green;
            }
            .removeUser{
              color: red;
            }

          }

          &.expiredDay{
            // background-color: #aaa;
            // background-image: linear-gradient(180deg, rgba(170, 170, 170, 1), rgba(0, 0, 0, 0.5));

            background-color: #aaaaaa;

            .day {
              color: white;
            }

            // cursor: not-allowed;

            .user{
              // cursor: not-allowed;
              background-color: #ff7c7c;
              border-color: #ff9f9f;

              b{
                display: none;
              }

              &.availableTurn {
                background-color: #ff5a5a;
                border-color: #ff9f9f;
              }
            }

            .user-plus{
              display: none;
            }
          }

          &.anotherMonth{
            background-color: #f4f4f4;
            &.expiredDay{
              background-image: linear-gradient(180deg, rgba(59, 59, 59, 1), rgba(59, 59, 59, 0.1));
              .day {
                color: white;
              }
              background-color: #555;
            }
          }

          .space{
            &:last-child{
              padding-bottom: 20px;
            }
            .space-turn{
              background-color: #dfdfdf;

            }
          }
        }

        &.disabled{
          opacity: 0.4;
          cursor: not-allowed;
          .turn{
            color: white;
            background-color: #aaa;
            .space{
              display: none;
            }
            .user{
              cursor: not-allowed;
            }
            .user-plus{
              display: none;
            }
            .removeUser{
              display: none;
            }
          }
        }
      }

      .send-pushs-bar{
        // width: 100%;
        // height: 60px;
        // position: absolute;
        // bottom: 10px;
        // background-color:green;
        // border-radius: 5px;
        position: relative;
        text-align: center;
        margin-top: 10px;

        .v-input--checkbox {
          position: absolute;
          top: -7px;
          right: 10px;
        }

        &.disabled{
          display: none;
        }

        // button{
        //   color: #fff;
        //   margin-top: 6px;
        //   font-size: 22px;
        // }
      }

      .send-pushs-bar-2{
        position: relative;
        text-align: center;
        margin-top: 10px;

        &.disabled{
          display: none;
        }
      }

      &.confirmedDutys{
        li{
          .space-turn{
            a{

              cursor: not-allowed;
            }
            .user-plus{
              display: none;
            }
            .removeUser{
              display: none;
            }
            .confirmedUser{
              display: block;
            }
          }
        }

      }
    }
  }
}

@media (max-width: 1024px) {
  .calendar-2 {
    .row {
      display: flex;
      overflow: auto;
      .morning,
      .night {
        &.morning,
        &.night {
          min-width: 1024px;
        }
      }
    }
  }
}

@media (max-width: 599px) {
  #scale-data {
    .calendar-2 {
      ul {
        li {
          .turn {
            max-width: none;
          }
        }
      }
    }
  }

  .calendar-2 {
    .row {
      .morning,
      .night {
        &.morning,
        &.night {
          min-width: auto;
        }
      }
    }

    ul {
      li {
        .turn{
          max-width: none;
        }
      }
    }
  }
}
</style>
